import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import ResponsiveBox, { Row, Col, Item, Location } from 'devextreme-react/responsive-box';
import AntWidgetChart from './AntWidgetChart';
import AntWidgetPieChart from './AntWidgetPieChart';
import AntWidgetStatisticGroup from './AntWidgetStatisticGroup';
import AntCondition from '../utils/AntCondition';
import AntLocalization from '../utils/AntLocalization';

import AntAPI from '../utils/AntAPI';

import cs from '../utils/const';
import { AntGlobal, AntSession } from '../utils/AntContext';

export default function (props) {
    const appGlobal = AntGlobal();
    // const session = AntSession();

    const [mainItems, setMainItems] = useState([]);

    const loadContent = useCallback(async (widgets) => {
        var items = widgets
            .map((r, index) => {
                var wConfig = r.config;
                var isVisible = AntCondition.isVisible(null, wConfig);
                if (!isVisible) return null;

                return {
                    ...r.config,
                    widget_group: r.group,
                    widget_code: r.code,
                    widget_name: r.name,
                    widget_type: r.type
                };
            })
            .filter((r) => Boolean(r));

        setMainItems(items);
    }, []);

    const renderItem = useCallback(
        (child, index) => {
            var totalSpan = 0;
            for (let i = 0; i < mainItems.length; i++) {
                if (i < index) {
                    const child2 = mainItems[i];
                    if (child2.colspan) totalSpan += child2.colspan;
                    else totalSpan += 1;
                }
            }
            // totalSpan+= (child.props && child.colspan ? child.colspan : 1);

            var lgRowIndex = parseInt(totalSpan / 10);
            var lgColIndex = totalSpan % 10;
            return (
                <Item key={index}>
                    <Location row={lgRowIndex} col={lgColIndex} colspan={child.colspan ? child.colspan : 1} screen="lg"></Location>
                    <Location row={index} col={0} colspan={1} screen="sm"></Location>

                    {child.widget_type === 'Chart' && (
                        <React.Fragment>
                            <div style={{ marginLeft: 0, marginRight: 0 }}>
                                {/* <AntAccordion  isH5={true} showIndex={false}> */}
                                <AntWidgetChart
                                    API={new AntAPI(child.moduleName, child.entityName, child.entityDisplay)}
                                    table={child.table}
                                    title={child.title}
                                    // showTitle={false}
                                    colspan={child.colspan}
                                    columns={child.columns}
                                    url={child.url}
                                    searchConditions={child.searchConditions}
                                    actionItems={child.actionItems}
                                    showActionBar={child.showActionBar}
                                    entityName={child.entityName}
                                    entityDisplay={child.entityDisplay}
                                    argumentField={child.argumentField}
                                    argumentFormat={child.argumentFormat}
                                    queryFields={child.queryFields}
                                    series1={child.series1}
                                    series2={child.series2}
                                    series3={child.series3}
                                    valueAxis={child.valueAxis}
                                    showLegend={child.showLegend}
                                    legend={child.legend}
                                />
                                {/* </AntAccordion> */}
                            </div>
                        </React.Fragment>
                    )}

                    {child.widget_type === 'DoughnutChart' && (
                        <React.Fragment>
                            <div style={{ marginLeft: 0, marginRight: 0 }}>
                                {/* <AntAccordion isH5={true} showIndex={false}> */}
                                <AntWidgetPieChart
                                    API={new AntAPI(child.moduleName, child.entityName, child.entityDisplay)}
                                    table={child.table}
                                    title={child.title}
                                    // showTitle={false}
                                    colspan={child.colspan}
                                    columns={child.columns}
                                    url={child.url}
                                    searchConditions={child.searchConditions}
                                    actionItems={child.actionItems}
                                    showActionBar={child.showActionBar}
                                    entityName={child.entityName}
                                    entityDisplay={child.entityDisplay}
                                    argumentField={child.argumentField}
                                    argumentFormat={child.argumentFormat}
                                    queryFields={child.queryFields}
                                    series1={child.series1}
                                    series2={child.series2}
                                    series3={child.series3}
                                    valueAxis={child.valueAxis}
                                    legend={child.legend}
                                />
                                {/* </AntAccordion> */}
                            </div>
                        </React.Fragment>
                    )}

                    {child.widget_type === 'StatisticGroup' && child.items instanceof Array && child.items.length > 0 && (
                        <React.Fragment>
                            <div style={{ marginLeft: 0, marginRight: 0 }}>
                                <AntWidgetStatisticGroup
                                    API={new AntAPI(child.moduleName, child.entityName, child.entityDisplay)}
                                    table={child.table}
                                    title={child.title}
                                    items={child.items}
                                    searchConditions={props.searchConditions}
                                    dataSource={props.dataSource}
                                    url={child.url}
                                />
                            </div>
                        </React.Fragment>
                    )}
                </Item>
            );
        },
        [mainItems, props.searchConditions, props.dataSource]
    );

    const renderItems = useCallback(() => {
        return mainItems.map(renderItem);
    }, [mainItems, renderItem]);

    useEffect(() => {
        loadContent(props.widgets);
    }, [props.widgets]);

    return (
        <React.Fragment>
            <ResponsiveBox
                singleColumnScreen="sm"
                screenByWidth={(width) => {
                    return width < 1000 ? 'sm' : 'lg';
                }}
            >
                <Col ratio={1}></Col>
                <Col ratio={1} screen="lg"></Col>
                <Col ratio={1} screen="lg"></Col>
                <Col ratio={1} screen="lg"></Col>
                <Col ratio={1} screen="lg"></Col>
                <Col ratio={1} screen="lg"></Col>
                <Col ratio={1} screen="lg"></Col>
                <Col ratio={1} screen="lg"></Col>
                <Col ratio={1} screen="lg"></Col>
                <Col ratio={1} screen="lg"></Col>

                {mainItems.map((child, index) => {
                    return <Row ratio={1} key={index}></Row>;
                })}

                {renderItems()}
            </ResponsiveBox>
        </React.Fragment>
    );
}
